import Collection from  './base';
import Trip from '../models/trip';

export default Collection.extend( {
	model: Trip,
} );
